import { styled } from '@linaria/react'
import React, { type FC } from 'react'
import { Logo as SvgLogo } from '@voteboxio/logo/svgr'
import { Typography } from '../ui/Typography'
import { colors } from '../styles/colors'
import { useTonConnect } from '../hooks/useTonConnect'
import { isTestnet } from '../shared/utils/network'
import { SvgLogoText } from '../svgr/LogoText'

interface LogoBlockProps {
  onClick?: () => void
}

export const LogoBlock: FC<LogoBlockProps> = ({ onClick }) => {
  const { network } = useTonConnect()

  return (
    <LogoContainer onClick={onClick}>
      <LogoWrapper>
        <SvgLogo width={38} height={30} />
        {isTestnet(network) && <TestBadge fontSize={9}>TESTNET</TestBadge>}
      </LogoWrapper>

      <Box>
        <SvgLogoText />
      </Box>
    </LogoContainer>
  )
}

const LogoContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr;
  gap: 8px;
  grid-gap: 8px;
  min-width: 0;
  cursor: pointer;

  @media (max-width: 360px) {
    gap: 6px;
    grid-gap: 6px;
  }
`

const LogoWrapper = styled.div`
  position: relative;
  display: inline-block;
`

const Box = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
`

const TestBadge = styled(Typography)`
  position: absolute;
  top: 4px;
  left: -5px;
  right: -5px;
  text-align: center;
  background: ${colors.dangerActive};
  color: ${colors.white};
  padding: 2px 4px;
  border-radius: 4px;
  box-shadow: 0 1px 3px ${colors.shadowMedium};
`
